module.exports = "/lucky-balls/img/bonus_yellow/header_maxbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_maxbet.png
// module id = 967
// module chunks = 0